import axios from 'axios';

//let root = "http://localhost";
let root = window.location.protocol + "//" + window.location.host;
let authHeader = {
    headers: {
        'Authorization': "Bearer " +  sessionStorage.getItem('token'),
        'X-Buddycom-From': "web-frontend",
    }
}
export default {
    post(path, json) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.headers.timeout = 30000;
        return axios.post(root + '/v2/api' + path, json, header)
		.catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            }
            if (error.message.indexOf("timeout") >= 0) {
    		    throw new Error("Timeout Error");
    		    return;
            }
            switch(error.response.status) {
                case 403:
                    window.location.href = './login.html';
                    break;
                default:
                    throw new Error("Server Error status=" + error.response.status);
                    break;
            }
		});
    },
    postWith2FA(path, json) {
        let authTmpHeader = { 
            headers: { 
                'Authorization': "Bearer " +  sessionStorage.getItem('twoPhaseToken'),
                'X-Auth-Type': '2FA'
            } 
        }
        let header = JSON.parse(JSON.stringify(authTmpHeader));
        header.headers.timeout = 20000;
        return axios.post(root + '/v2/api' + path, json, header)
		.catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            }
            if (error.message.indexOf("timeout") >= 0) {
    		    throw new Error("Timeout Error");
    		    return;
            }
            switch(error.response.status) {
                case 403:
                    window.location.href = './login.html';
                    break;
                default:
                    throw new Error("Server Error status=" + error.response.status);
                    break;
            }
		});
    },
    postWithFile(path, uploadFile, param) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.headers['content-type'] = 'multipart/form-data; charset="utf-8"';
        let formData = new FormData();
        if (uploadFile != null) {
            formData.append('uploadFile', uploadFile);
        }
        formData.append('requestParam', param);
        return axios.post(root + '/v2/api' + path, formData, header)
		.catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
    		    return;
            }
            if (error.message.indexOf("timeout") >= 0) {
    		    throw new Error("Timeout Error");
    		    return;
            }
            switch(error.response.status) {
                case 403:
                    window.location.href = './login.html';
                    break;
                default:
                    throw new Error("Server Error status=" + error.response.status);
                    break;
            }
		});
    },
    downloadBlob(path, json) {
        let header = JSON.parse(JSON.stringify(authHeader));
        header.responseType = 'blob';
        return axios.post(root + '/v2/api/' + path, json, header )
        .catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            } else {
		        switch(error.response.status) {
                    case 403:
                        window.location.href = './login.html';
                        break;
                    default:
            		    throw new Error("Server Error status=" + error.response.status);
            		    break;
                }
            }
        });
    },
    downloadBinaryFile(path) {
        return axios.get(path,  { responseType : 'blob' })
        .catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            } else {
		        switch(error.response.status) {
                    case 403:
                        window.location.href = './login.html';
                        break;
                    default:
            		    throw new Error("Server Error status=" + error.response.status);
            		    break;
                }
            }
        });
    },
    postNoError(path, json) {
        return axios.post(root + '/v2/api' + path, json, authHeader )
        .catch(error => {
            if (error.message.indexOf("Network Error") >= 0) {
    		    throw new Error("Network Error");
            } else {
                throw new Error("Server Error status=" + error.response.status);
            }
        });
    },

};

